import { render } from "./GobImagenAmpliable.vue?vue&type=template&id=61f4463f&scoped=true"
import script from "./GobImagenAmpliable.vue?vue&type=script&lang=js"
export * from "./GobImagenAmpliable.vue?vue&type=script&lang=js"

import "./GobImagenAmpliable.vue?vue&type=style&index=0&id=61f4463f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f4463f"]])

export default __exports__